  document.addEventListener('DOMContentLoaded', function() {
    var popup = document.getElementById('popup');
    var closeButton = document.querySelector('.close-button');
    var filterButton = document.getElementById('filterButton');
    var accordions = document.getElementsByClassName('accordion');

    function openPopup() {
      if (window.innerWidth < 768) {
        popup.style.display = 'block';
      }
    }
    
    closeButton.addEventListener('click', function() {
      popup.style.display = 'none';
    });

    filterButton.addEventListener('click', openPopup);

    window.addEventListener('resize', function() {
      // Hide the popup if the screen is resized to be wider than 768px while it's open
      if (window.innerWidth >= 768) {
        popup.style.display = 'none';
      }
    });

    // Accordion functionality
    for (var i = 0; i < accordions.length; i++) {
        accordions[i].addEventListener('click', function() {
            // Close all other panels
            for (var j = 0; j < accordions.length; j++) {
                if (accordions[j] !== this) {
                    accordions[j].classList.remove('active');
                    accordions[j].nextElementSibling.classList.remove('show');
                }
            }

            // Toggle the clicked panel
            this.classList.toggle('active');
            var panel = this.nextElementSibling;
            panel.classList.toggle('show');
        });
    }
});

//--------------------------------------------------------
//--------------------------------------------------------
document.addEventListener('DOMContentLoaded', function() {

    var show_hide_msgDiv = 'hide';
    // Get collection handle and category from sessionStorage
    const handle = sessionStorage.getItem('collectionHandle');
    //console.log('clciked collection: ',handle);
    // const category = sessionStorage.getItem('collectionCategory');
    // if (!category) {
    //   window.location.href = '/';
    // }
    // console.log('category', category);
    
    //Right now only one category available
    const category = 'core';
    //console.log('category', category);

    //--------------------------------------------------------
    //----------------- Declare variables --------------------
    //--------------------------------------------------------
    const collectionCheckboxes = document.querySelectorAll('.collection-checkbox');
    const products = document.querySelectorAll('.product_block');
    const activeCheckbox = document.getElementById('active');
    const deactivatedCheckbox = document.getElementById('deactivated');
    const priceCheckboxes = document.querySelectorAll('.price-checkbox');
    
    const resetButtonMain = document.getElementById('reset-filters-main');
    const resetButton = document.getElementById('reset-filters');
    const bodyFont = getComputedStyle(document.documentElement).getPropertyValue('--bodyFont');

    const priceRange = [
      "1-99",
      "100-299",
      "300-499",
      "500-699",
      "700-999",
      "1000-1999",
      "2000-2999",
      "3000-3999",
      "4000-4999",
      "5000-5999",
      "6000-6999"
    ];

    const colors = [
      "Black",
      "White",
      "Blue",
      "Gray",
      "Green",
      "Silver",
      "Champagne",
      "Mother of Pearl",
      "<etallic S",
      "Ivory",
      "Gold",
      "Copper",
      "Pink",
      "Brown",
      "Yellow",
      "Burgundy",
      "Digital",
      "Orange",
      "Red",
      "Rose Gold",
      "Beige",
      "Charcoal",
      "Purple",
      "Light Blue",
      "Turquoise"
    ];

    const sizeRange = [
      "BELOW 28.0MM",
      "28.0MM-31.9MM",
      "32.0MM-35.9MM",
      "36.0MM-39.9MM",
      "40.0MM-42.9MM",
      "43.0MM AND ABOVE"
    ];

    const technologysRange = [
      "Automatic",
      "Automatic GMT",
      "Quartz",
      "Quartz Chronograph",
      "Solar Chronograph",
      "Radio Sync Solar",
      "Solar",
      "Solar GMT",
      "N\/A",
      "Solar Analog-Digital"
    ];

    const materialsRange = [
      "Leather Strap",
      "Mesh",
      "Nylon Strap",
      "Silicone",
      "Stainless Steel",
      "Titanium"
    ];
    
    //-----------------------------------------------
    // Function to show collections based on category
    //-----------------------------------------------
    function showCollectionsByCategory(category) {
      const coreCollectionsContainer = document.getElementById('core-collections');
      const luxeCollectionsContainer = document.getElementById('luxe-collections');

      // Show core collections
      if (category == 'core') {
          coreCollectionsContainer.style.display = 'block';
          coreCollectionsContainer.style.marginTop = '15px';
          document.getElementById('luxe-collections').style.display = 'none';

        // Apply styles to core collection items
        const coreItems = coreCollectionsContainer.querySelectorAll('.collection-item-collect');
        coreItems.forEach(item => {
          item.style.display = 'flex';
          item.style.alignItems = 'center';  // Center vertically
          item.style.justifyContent = 'flex-start';  // Align to the left
          item.style.marginBottom = '3px';

          const checkbox = item.querySelector('.collection-checkbox');
          checkbox.style.width = '16px';
          checkbox.style.height = '16px';
          checkbox.style.marginRight = '10px';  // Space between checkbox and label

          const label = item.querySelector('label');
          label.style.marginTop = '5px';
          label.style.fontSize = '16px';
          label.style.fontWeight = '600';
        });
      } 
      else if (category == 'luxe') {
        
          document.getElementById('core-collections').style.display = 'none';
          luxeCollectionsContainer.style.display = 'block';
          luxeCollectionsContainer.style.marginTop = '15px';

        const luxeItems = luxeCollectionsContainer.querySelectorAll('.collection-item-collect');
        luxeItems.forEach(item => {
          item.style.display = 'flex';
          item.style.alignItems = 'center';  // Center vertically
          item.style.justifyContent = 'flex-start';  // Align to the left
          item.style.marginBottom = '3px';

          const checkbox = item.querySelector('.collection-checkbox');
          checkbox.style.width = '16px';
          checkbox.style.height = '16px';
          checkbox.style.marginRight = '10px';  // Space between checkbox and label

          const label = item.querySelector('label');
          label.style.marginTop = '5px';
          label.style.fontSize = '16px';
          label.style.fontWeight = '600';
        });
      }
    }
    
    showCollectionsByCategory(category);
    
    
    //-----------------------------------------------
    // Update price tags based on collection
    //-----------------------------------------------

    function extractPricesFromFilters(filters) {
      if (!filters) return [];

      const matches = filters.match(/filter-price-[^|]+/g);
      if (!matches) return [];

      return matches.map(p =>
        p.replace('filter-price-', '').toLowerCase()
      );
    }

    function sortPrices(a, b) {
      const getStart = v =>
        parseInt(v.replace(/[^0-9]/g, ''), 10) || 999999;

      return getStart(a) - getStart(b);
    }

    const selectedPrices = new Set(); // To store unique prices
    let selectedPriceValues = [];
    
    function updatePriceTags(selectedCollections) {
      const priceTagsContainer = document.getElementById('price-tags');
      priceTagsContainer.innerHTML = ''; // Clear existing price tags
      selectedPrices.clear();
      
      // Loop through products
      for (let i = 0; i < products.length; i++) {
        const product = products[i];
        const productCollection = product.getAttribute('data-collection');
        const filters = product.getAttribute('data-filters');
        
        // Check if the product belongs to any of the selected collections
        if (selectedCollections.includes(productCollection) && product.style.display != 'none') {
          
          const prices = extractPricesFromFilters(filters);

          prices.forEach(price => {
            selectedPrices.add(price);
          });
        }
      }
      
      // Create custom dropdown
      const customDropdown = document.createElement('div');
      customDropdown.classList.add('custom-dropdown');
      
      // Create the selected item div
      const selectSelected = document.createElement('div');
      selectSelected.classList.add('select-selected');
      
      // Check if there are selected prices, if so, set the first one as the default selected value
      if(selectedPriceValues.length > 0) {
        selectSelected.textContent = selectedPriceValues[0];
      } 
      else {
        selectSelected.textContent = 'Price';
        selectSelected.style.fontFamily = bodyFont;
      }
      customDropdown.appendChild(selectSelected);
      
      // Create the dropdown items div
      const selectItems = document.createElement('div');
      selectItems.classList.add('select-items');

      [...selectedPrices]
      .sort(sortPrices)
      .forEach(price => {
        const optionDiv = document.createElement('div');
        optionDiv.textContent = price;
        optionDiv.style.fontFamily = bodyFont;

        optionDiv.addEventListener('click', function () {
          selectSelected.textContent = price;
          selectedPriceValues = [price];
          filterProducts();
          selectItems.style.display = 'none';
        });

        selectItems.appendChild(optionDiv);
      });
      
      // selectedPrices.forEach(price => {
      //   const optionDiv = document.createElement('div');
      //   optionDiv.textContent = price;
      //   optionDiv.style.fontFamily = bodyFont;
        
      //   optionDiv.addEventListener('click', function() {
      //     selectSelected.textContent = this.textContent;
      //     selectedPriceValues = [this.textContent];
      //     console.log('Selected price value:', this.textContent);
          
      //     filterProducts(); // Call the function after updating selectedPriceValues
      //     selectItems.style.display = 'none'; // Hide the dropdown items
      //   });
      //   selectItems.appendChild(optionDiv);
      // });
      
      customDropdown.appendChild(selectItems);
      priceTagsContainer.appendChild(customDropdown);
      
      selectSelected.addEventListener('click', function() {
        selectItems.style.display = selectItems.style.display === 'block' ? 'none' : 'block';
      });
      
      document.addEventListener('click', function(e) {
        if (!customDropdown.contains(e.target)) {
          selectItems.style.display = 'none';
        }
      });
    }

    //-----------------------------------------------
    // Update price tags based on collection when the 
    // accordion is clicked
    //-----------------------------------------------
    function updatePriceTagsAccordionn(panelId, selectedCollections) {
      const pricePanel = document.getElementById(panelId);
      const priceTagsContainer = pricePanel.querySelector('.tag-list');
      priceTagsContainer.innerHTML = ''; // Clear existing price tags
      selectedPrices.clear();
  
      // Loop through products
      for (let i = 0; i < products.length; i++) {
        const product = products[i];
        const productCollection = products[i].getAttribute('data-collection');
        const filters = products[i].getAttribute('data-filters');
  
          // Check if the product belongs to any of the selected collections
        if (selectedCollections.includes(productCollection) && product.style.display != 'none') {
          
          const prices = extractPricesFromFilters(filters);

          prices.forEach(price => {
            selectedPrices.add(price);
          });
        }
      }

      //if user reset filters show default value
      if (selectedPriceValues.length == 0) {
        var button = document.getElementById("price-btn");
        button.innerHTML = '<i class="arrow down" style="margin-left:8px;margin-right:8px;"></i>' + "<b>" + "Price" + "</b>" ;
        button.classList.add("accordion");
        button.style.fontFamily = bodyFont;
      }
      else {
        var button = document.getElementById("price-btn");
        button.innerHTML = '<i class="arrow down" style="margin-left:8px;margin-right:8px;"></i>' + "<b>Price " + "(" + selectedPriceValues[0] + ") </b>" ;
        button.classList.add("accordion");
        button.style.fontFamily = bodyFont;
      }
  
      // Populate the price values within the panel
      selectedPrices.forEach(price => {
          const li = document.createElement('li');
          li.classList.add('tag');
          li.textContent = price;
          li.style.fontFamily = bodyFont;
          priceTagsContainer.appendChild(li);
  
          // Add click event listener to each tag item
          li.addEventListener('click', function() {
              // Handle selection here
            selectedPriceValues = [this.textContent];

            var button = document.getElementById("price-btn");
            button.innerHTML = '<i class="arrow down" style="margin-left:8px;margin-right:8px;"></i>' + "<b>Price " + "(" + selectedPriceValues[0] + ") </b>" ;
            button.classList.add("accordion");
            button.style.fontFamily = bodyFont;
            
            filterProducts();
          });
      });

      // console.log('popup', selectedPrices);
    }
    
    
    //-----------------------------------------------
    // Update color tags based on collection
    //-----------------------------------------------

    function extractColorsFromFilters(filters) {
      if (!filters) return [];

      const matches = filters.match(/filter-dial-color-[^|]+/g);
      if (!matches) return [];

      return matches.map(c =>
        c.replace('filter-dial-color-', '').trim() // lowercase here
      );
    }

    const selectedColors = new Set();
    let selectedColorValues = [];
    
    function updateColorTags(selectedCollections) {
      const colorTagsContainer = document.getElementById('color-tags');
      colorTagsContainer.innerHTML = '';
      selectedColors.clear();

      for (let i = 0; i < products.length; i++) {
        const product = products[i];
        const productCollection = product.getAttribute('data-collection');
        const filters = product.getAttribute('data-filters');

        if (selectedCollections.includes(productCollection) && product.style.display !== 'none') {
          // dynamic color extraction
          const colors = extractColorsFromFilters(filters);

          colors.forEach(color => {
            selectedColors.add(color);
          });
        }
      }
      
      // Create custom dropdown
      const customDropdown = document.createElement('div');
      customDropdown.classList.add('custom-dropdown');
      
      // Create the selected item div
      const selectSelected = document.createElement('div');
      selectSelected.classList.add('select-selected');
      
      // Check if there are selected selectedColors, if so, set the first one as the default selected value
      if(selectedColorValues.length > 0) {
        selectSelected.textContent = selectedColorValues[0];
      } else {
        selectSelected.textContent = 'Color';
        selectSelected.style.fontFamily = bodyFont;
      }
      customDropdown.appendChild(selectSelected);
      
      // Create the dropdown items div
      const selectItems = document.createElement('div');
      selectItems.classList.add('select-items');
      
      selectedColors.forEach(color => {
        const optionDiv = document.createElement('div');
        optionDiv.textContent = color;
        optionDiv.style.fontFamily = bodyFont;
        
        optionDiv.addEventListener('click', function() {
          selectSelected.textContent = this.textContent;
          selectedColorValues = [this.textContent.toLowerCase()]; // lowercase
          //console.log('Selected color value:', this.textContent);

          filterProducts(); // Call the function after updating selectedColorValues
          selectItems.style.display = 'none'; // Hide the dropdown items
        });
        selectItems.appendChild(optionDiv);
      });
      
      customDropdown.appendChild(selectItems);
      colorTagsContainer.appendChild(customDropdown);
      
      selectSelected.addEventListener('click', function() {
        selectItems.style.display = selectItems.style.display === 'block' ? 'none' : 'block';
      });
      
      document.addEventListener('click', function(e) {
        if (!customDropdown.contains(e.target)) {
          selectItems.style.display = 'none';
        }
      });
    }

    //-----------------------------------------------
    // Update color tags based on collection when the 
    // accordion is clicked
    //-----------------------------------------------
    function updateColorTagsAccordionn(panelId, selectedCollections) {
      const colorPanel = document.getElementById(panelId);
      const colorTagsContainer = colorPanel.querySelector('.tag-list');
      colorTagsContainer.innerHTML = ''; // Clear existing color tags
      selectedColors.clear();
  
      // Loop through products
      for (let i = 0; i < products.length; i++) {
        const product = products[i];
        const productCollection = product.getAttribute('data-collection');
        const filters = product.getAttribute('data-filters');

        if (selectedCollections.includes(productCollection) && product.style.display != 'none') {
          // dynamic color extraction
          const colors = extractColorsFromFilters(filters);

          colors.forEach(color => {
            selectedColors.add(color);
          });
        }
      }

      //if user reset filters show default value
      if (selectedColorValues.length == 0) {
        var button = document.getElementById("color-btn");
        button.innerHTML = '<i class="arrow down" style="margin-left:8px;margin-right:8px;"></i>' + "<b>" + "Color" + "</b>" ;
        button.classList.add("accordion");
        button.style.fontFamily = bodyFont;
      }
      else {
        var button = document.getElementById("color-btn");
        button.innerHTML = '<i class="arrow down" style="margin-left:8px;margin-right:8px;"></i>' + "<b>Color " + "(" + selectedColorValues[0] + ") </b>" ;
        button.classList.add("accordion");
        button.style.fontFamily = bodyFont;
      }
  
      // Populate the color values within the panel
      selectedColors.forEach(color => {
          const li = document.createElement('li');
          li.classList.add('tag');
          li.textContent = color;
          li.style.fontFamily = bodyFont;
          colorTagsContainer.appendChild(li);
  
          // Add click event listener to each tag item
          li.addEventListener('click', function() {
            // Handle selection here
            selectedColorValues = [this.textContent.toLowerCase()];

            var button = document.getElementById("color-btn");
            button.innerHTML = '<i class="arrow down" style="margin-left:8px;margin-right:8px;"></i>' + "<b>Color " + "(" + selectedColorValues[0] + ") </b>" ;
            button.classList.add("accordion");
            button.style.fontFamily = bodyFont;
            
            filterProducts();
            //console.log('Selected color popup:', this.textContent);
          });
      });
    }
    
    
    //-----------------------------------------------
    // Update size tags based on collection
    //-----------------------------------------------
    function extractSizesFromFilters(filters) {
      if (!filters) return [];

      const matches = filters.match(/filter-case-size-[^|]+/g);
      if (!matches) return [];

      return matches.map(s => s.replace('filter-case-size-', '').trim());
    }

    const selectedSizes = new Set(); // To store unique sizes
    let selectedSizeValues = [];
    
    function updateSizeTags(selectedCollections) {
      const sizeTagsContainer = document.getElementById('size-tags');
      sizeTagsContainer.innerHTML = ''; // Clear existing size tags
      selectedSizes.clear();
      
      // Loop through products
      for (let i = 0; i < products.length; i++) {
        const product = products[i];
        const productCollection = product.getAttribute('data-collection');
        const filters = product.getAttribute('data-filters');

        if (selectedCollections.includes(productCollection) && product.style.display !== 'none') {
          // dynamic size extraction
          const sizes = extractSizesFromFilters(filters);
          sizes.forEach(size => selectedSizes.add(size));
        }
      }
      
      // Create custom dropdown
      const customDropdown = document.createElement('div');
      customDropdown.classList.add('custom-dropdown');
      
      // Create the selected item div
      const selectSelected = document.createElement('div');
      selectSelected.classList.add('select-selected');
      
      // Check if there are selected selectedSizes, if so, set the first one as the default selected value
      if(selectedSizeValues.length > 0) {
        selectSelected.textContent = selectedSizeValues[0];
      } else {
        selectSelected.textContent = 'Size';
        selectSelected.style.fontFamily = bodyFont;
      }
      customDropdown.appendChild(selectSelected);
      
      // Create the dropdown items div
      const selectItems = document.createElement('div');
      selectItems.classList.add('select-items');
      
      selectedSizes.forEach(size => {
        const optionDiv = document.createElement('div');
        optionDiv.textContent = size;
        optionDiv.style.fontFamily = bodyFont;
        
        optionDiv.addEventListener('click', function() {
          selectSelected.textContent = this.textContent;
          selectedSizeValues = [this.textContent.toLowerCase()];
          //console.log('Selected size value:', this.textContent);
          
          filterProducts(); // Call the function after updating selectedSizeValues
          selectItems.style.display = 'none'; // Hide the dropdown items
        });
        selectItems.appendChild(optionDiv);
      });
      
      customDropdown.appendChild(selectItems);
      sizeTagsContainer.appendChild(customDropdown);
      
      selectSelected.addEventListener('click', function() {
        selectItems.style.display = selectItems.style.display === 'block' ? 'none' : 'block';
      });
      
      document.addEventListener('click', function(e) {
        if (!customDropdown.contains(e.target)) {
          selectItems.style.display = 'none';
        }
      });
    }
    
    //-----------------------------------------------
    // Update size tags based on collection when the 
    // accordion is clicked
    //-----------------------------------------------
    function updateSizeTagsAccordionn(panelId, selectedCollections) {
      const sizePanel = document.getElementById(panelId);
      const sizeTagsContainer = sizePanel.querySelector('.tag-list');
      sizeTagsContainer.innerHTML = ''; // Clear existing size tags
      selectedSizes.clear();
  
      // Loop through products
      for (let i = 0; i < products.length; i++) {
        const product = products[i];
        const productCollection = product.getAttribute('data-collection');
        const filters = product.getAttribute('data-filters');

        if (selectedCollections.includes(productCollection) && product.style.display !== 'none') {
          // dynamic size extraction
          const sizes = extractSizesFromFilters(filters);
          sizes.forEach(size => selectedSizes.add(size));
        }
      }

      //if user reset filters show default value
      if (selectedSizeValues.length == 0) {
        var button = document.getElementById("size-btn");
        button.innerHTML = '<i class="arrow down" style="margin-left:8px;margin-right:8px;"></i>' + "<b>" + "Size" + "</b>" ;
        button.classList.add("accordion");
        button.style.fontFamily = bodyFont;
      }
      else {
        var button = document.getElementById("size-btn");
        button.innerHTML = '<i class="arrow down" style="margin-left:8px;margin-right:8px;"></i>' + "<b>Size " + "(" + selectedSizeValues[0] + ") </b>" ;
        button.classList.add("accordion");
        button.style.fontFamily = bodyFont;
      }
  
      // Populate the size values within the panel
      selectedSizes.forEach(size => {
          const li = document.createElement('li');
          li.classList.add('tag');
          li.textContent = size;
          li.style.fontFamily = bodyFont;
          sizeTagsContainer.appendChild(li);
  
          // Add click event listener to each tag item
          li.addEventListener('click', function() {
              // Handle selection here
            selectedSizeValues = [this.textContent.toLowerCase()];

            var button = document.getElementById("size-btn");
            button.innerHTML = '<i class="arrow down" style="margin-left:8px;margin-right:8px;"></i>' + "<b>Size " + "(" + selectedSizeValues[0] + ") </b>" ;
            button.classList.add("accordion");
            button.style.fontFamily = bodyFont;
            
            filterProducts();
            //console.log('Selected size:', this.textContent);
          });
      });
    }
    

    //-----------------------------------------------
    // Update technologys tags based on collection
    //-----------------------------------------------

    function extractTechnologiesFromFilters(filters) {
      if (!filters) return [];

      const matches = filters.match(/filter-movement-type-[^|]+/g);
      if (!matches) return [];

      return matches.map(t => t.replace('filter-movement-type-', '').trim());
    }

    const selectedtechnologys = new Set(); // To store unique sizes
    let selectedtechnologyValues = [];
    
    function updatetechnologyTags(selectedCollections) {
      const technologyTagsContainer = document.getElementById('technology-tags');
      technologyTagsContainer.innerHTML = ''; // Clear existing technology tags
      selectedtechnologys.clear();
      
      // Loop through products
      for (let i = 0; i < products.length; i++) {
        const product = products[i];
        const productCollection = product.getAttribute('data-collection');
        const filters = product.getAttribute('data-filters');

        if (
          selectedCollections.includes(productCollection) &&
          product.style.display !== 'none'
        ) {
          const technologies = extractTechnologiesFromFilters(filters);
          technologies.forEach(t => selectedtechnologys.add(t));
        }
      }
      
      // Create custom dropdown
      const customDropdown = document.createElement('div');
      customDropdown.classList.add('custom-dropdown');
      
      // Create the selected item div
      const selectSelected = document.createElement('div');
      selectSelected.classList.add('select-selected');
      
      // Check if there are selected selectedtechnologys, if so, set the first one as the default selected value
      if(selectedtechnologyValues.length > 0) {
        selectSelected.textContent = selectedtechnologyValues[0];
      } else {
        selectSelected.textContent = 'Technology';
        selectSelected.style.fontFamily = bodyFont;
      }
      customDropdown.appendChild(selectSelected);
      
      // Create the dropdown items div
      const selectItems = document.createElement('div');
      selectItems.classList.add('select-items');
      
      selectedtechnologys.forEach(technology => {
        const optionDiv = document.createElement('div');
        optionDiv.textContent = technology;
        optionDiv.style.fontFamily = bodyFont;
        
        optionDiv.addEventListener('click', function() {
          selectSelected.textContent = this.textContent;
          selectedtechnologyValues = [this.textContent.toLowerCase()];
          //console.log('Selected technology value:', this.textContent);
          
          filterProducts(); // Call the function after updating selectedtechnologyValues
          selectItems.style.display = 'none'; // Hide the dropdown items
        });
        selectItems.appendChild(optionDiv);
      });
      
      customDropdown.appendChild(selectItems);
      technologyTagsContainer.appendChild(customDropdown);
      
      selectSelected.addEventListener('click', function() {
        selectItems.style.display = selectItems.style.display === 'block' ? 'none' : 'block';
      });
      
      document.addEventListener('click', function(e) {
        if (!customDropdown.contains(e.target)) {
          selectItems.style.display = 'none';
        }
      });
    }

    //-----------------------------------------------
    // Update technology tags based on collection 
    // when the accordion is clicked
    //-----------------------------------------------
    function updateTechnologyTagsAccordionn(panelId, selectedCollections) {
      const technologyPanel = document.getElementById(panelId);
      const technologyTagsContainer = technologyPanel.querySelector('.tag-list');
      technologyTagsContainer.innerHTML = ''; // Clear existing technology tags
      selectedtechnologys.clear();
  
      // Loop through products
      for (let i = 0; i < products.length; i++) {
        const product = products[i];
        const productCollection = product.getAttribute('data-collection');
        const filters = product.getAttribute('data-filters');

        if (
          selectedCollections.includes(productCollection) &&
          product.style.display !== 'none'
        ) {
          const technologies = extractTechnologiesFromFilters(filters);
          technologies.forEach(t => selectedtechnologys.add(t));
        }
      }

      //if user reset filters show default value
      if (selectedtechnologyValues.length == 0) {
        var button = document.getElementById("technology-btn");
        button.innerHTML = '<i class="arrow down" style="margin-left:8px;margin-right:8px;"></i>' + "<b>" + "Technology" + "</b>" ;
        button.classList.add("accordion");
        button.style.fontFamily = bodyFont;
      }
      else {
        var button = document.getElementById("technology-btn");
        button.innerHTML = '<i class="arrow down" style="margin-left:8px;margin-right:8px;"></i>' + "<b>Technology " + "(" + selectedtechnologyValues[0] + ") </b>" ;
        button.classList.add("accordion");
        button.style.fontFamily = bodyFont;
      }
  
      // Populate the technology values within the panel
      selectedtechnologys.forEach(technology => {
          const li = document.createElement('li');
          li.classList.add('tag');
          li.textContent = technology;
          li.style.fontFamily = bodyFont;
          technologyTagsContainer.appendChild(li);
  
          // Add click event listener to each tag item
          li.addEventListener('click', function() {
            // Handle selection here
            selectedtechnologyValues = [this.textContent.toLowerCase()];

            var button = document.getElementById("technology-btn");
            button.innerHTML = '<i class="arrow down" style="margin-left:8px;margin-right:8px;"></i>' + "<b>Technology " + "(" + selectedtechnologyValues[0] + ") </b>" ;
            button.classList.add("accordion");
            button.style.fontFamily = bodyFont;
            
            filterProducts();
            //console.log('Selected technology:', this.textContent);
          });
      });
    }
    

    //-----------------------------------------------
    // Update materials tags based on collection
    //-----------------------------------------------
    function extractMaterialsFromFilters(filters) {
      if (!filters) return [];

      const matches = filters.match(/filter-material-[^|]+/g);
      if (!matches) return [];

      return matches.map(s => s.replace('filter-material-', '').trim());
    }

    const selectedmaterials = new Set(); // To store unique materials
    let selectedmaterialValues = [];
    
    function updatematerialTags(selectedCollections) {
      const materialTagsContainer = document.getElementById('material-tags');
      materialTagsContainer.innerHTML = ''; // Clear existing material tags
      selectedmaterials.clear();
      
      // Loop through products
      for (let i = 0; i < products.length; i++) {
        const product = products[i];
        const productCollection = product.getAttribute('data-collection');
        const filters = product.getAttribute('data-filters');

        if (selectedCollections.includes(productCollection) && product.style.display !== 'none') {
          // dynamic material extraction
          const materials = extractMaterialsFromFilters(filters);
          materials.forEach(mat => selectedmaterials.add(mat));
        }
      }
      
      // Create custom dropdown
      const customDropdown = document.createElement('div');
      customDropdown.classList.add('custom-dropdown');
      
      // Create the selected item div
      const selectSelected = document.createElement('div');
      selectSelected.classList.add('select-selected');
      
      // Check if there are selected selectedmaterials, if so, set the first one as the default selected value
      if(selectedmaterialValues.length > 0) {
        selectSelected.textContent = selectedmaterialValues[0];
      } else {
        selectSelected.textContent = 'Material';
        selectSelected.style.fontFamily = bodyFont;
      }
      customDropdown.appendChild(selectSelected);
      
      // Create the dropdown items div
      const selectItems = document.createElement('div');
      selectItems.classList.add('select-items');
      
      selectedmaterials.forEach(material => {
        const optionDiv = document.createElement('div');
        optionDiv.textContent = material;
        optionDiv.style.fontFamily = bodyFont;
        
        optionDiv.addEventListener('click', function() {
          selectSelected.textContent = this.textContent;
          selectedmaterialValues = [this.textContent.toLowerCase()];
          //console.log('Selected material value:', this.textContent);
          
          filterProducts(); // Call the function after updating selectedmaterialValues
          selectItems.style.display = 'none'; // Hide the dropdown items
        });
        selectItems.appendChild(optionDiv);
      });
      
      customDropdown.appendChild(selectItems);
      materialTagsContainer.appendChild(customDropdown);
      
      selectSelected.addEventListener('click', function() {
        selectItems.style.display = selectItems.style.display === 'block' ? 'none' : 'block';
      });
      
      document.addEventListener('click', function(e) {
        if (!customDropdown.contains(e.target)) {
          selectItems.style.display = 'none';
        }
      });
    }

    //-----------------------------------------------
    // Update material tags based on collection when
    // the accordion is clicked
    //-----------------------------------------------
    function updateMaterialTagsAccordionn(panelId, selectedCollections) {
      const materialPanel = document.getElementById(panelId);
      const materialTagsContainer = materialPanel.querySelector('.tag-list');
      materialTagsContainer.innerHTML = ''; // Clear existing material tags
      selectedmaterials.clear();
  
      // Loop through products
      for (let i = 0; i < products.length; i++) {
        const product = products[i];
        const productCollection = product.getAttribute('data-collection');
        const filters = product.getAttribute('data-filters');

        if (selectedCollections.includes(productCollection) && product.style.display !== 'none') {
          // dynamic material extraction
          const materials = extractMaterialsFromFilters(filters);
          materials.forEach(mat => selectedmaterials.add(mat));
        }
      }

      //if user reset filters show default value
      if (selectedmaterialValues.length == 0) {
        var button = document.getElementById("material-btn");
        button.innerHTML = '<i class="arrow down" style="margin-left:8px;margin-right:8px;"></i>' + "<b>" + "Material" + "</b>" ;
        button.classList.add("accordion");
        button.style.fontFamily = bodyFont;
      }
      else {
        var button = document.getElementById("material-btn");
        button.innerHTML = '<i class="arrow down" style="margin-left:8px;margin-right:8px;"></i>' + "<b>Material " + "(" + selectedmaterialValues[0] + ") </b>" ;
        button.classList.add("accordion");
        button.style.fontFamily = bodyFont;
      }
      
      // Populate the material values within the panel
      selectedmaterials.forEach(material => {
          const li = document.createElement('li');
          li.classList.add('tag');
          li.textContent = material;
          li.style.fontFamily = bodyFont;
          materialTagsContainer.appendChild(li);
  
          // Add click event listener to each tag item
          li.addEventListener('click', function() {
            
            selectedmaterialValues = [this.textContent.toLowerCase()];

            var button = document.getElementById("material-btn");
            button.innerHTML = '<i class="arrow down" style="margin-left:8px;margin-right:8px;"></i>' + "<b>Material " + "(" + selectedmaterialValues[0] + ") </b>" ;
            button.classList.add("accordion");
            button.style.fontFamily = bodyFont;
            
            filterProducts();
            //console.log('Selected material popup:', this.textContent);
          });
      });
    }
    
    
    //------------------------------------------------------------------------------------
    // If a collection handle exists, check the corresponding checkbox and filter products
    //-----------------------------------------------------------------------------------
    if (handle) {
        const checkbox = document.querySelector(`.collection-checkbox[value="${handle}"]`);
        if (checkbox) {
          checkbox.checked = true;
          filterProducts();
        }
    }

    //-----------------------------------------------------------------------------------
    // Add event listeners to collection checkboxes and active and deactivated checkboxes
    //-----------------------------------------------------------------------------------
    collectionCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', filterProducts);
    });

    activeCheckbox.addEventListener('change', filterProducts);
    deactivatedCheckbox.addEventListener('change', filterProducts);

    //-------------------------------------------------------------------------
    // Function to filter products based on selected collections and checkboxes
    //-------------------------------------------------------------------------
    if (category == 'luxe' && handle == 'all') {
      filterProducts();
    }
    else if (category == 'core' && handle == 'all') {
      filterProducts();
    }
    
    function filterProducts() {
        const selectedCollections = [];
        for (let i = 0; i < collectionCheckboxes.length; i++) {
          if (collectionCheckboxes[i].checked) {
            selectedCollections.push(collectionCheckboxes[i].value);
          }
        }
      
        const activeChecked = activeCheckbox.checked;
        const deactivatedChecked = deactivatedCheckbox.checked;

        //it will not add 'all' handle in selectedCollections as default
        if (handle != 'all') {
          // Use default selected handle if no collections are selected
          
          if (selectedCollections.length == 0) {
            //console.log('selectedCollections_inside', selectedCollections);
            if (handle) {
                selectedCollections.push(handle);
            }
          }
        }      
        
        // console.log('Selected Collections:', selectedCollections);
        // console.log('Active Checked:', activeChecked);
        // console.log('Deactivated Checked:', deactivatedChecked);
      
        if (selectedCollections.length > 0) {
          console.log('products.length', products.length);
          for (let i = 0; i < products.length; i++) {
            const productCollectionLower = products[i].getAttribute('data-collection');
            const productCollection = productCollectionLower.toLowerCase();
            
            const filtersLower = products[i].getAttribute('data-filters');
            const filters = filtersLower.toLowerCase();
            // console.log('filters', filters);

            if (selectedCollections.includes(productCollection)) {

              if (!activeChecked && !deactivatedChecked) {
                
                // Display products for selected collections without filtering by active/deactivated
                if (category == 'luxe') {
                  if (filters.includes('|luxe_active|') || filters.includes('|luxe_deactivated|')) {
                    
                      if(filters.includes(selectedPriceValues)) {  //check if filters contains any selectedPriceValues

                        // --------------- color filters
                        if (filters.includes(selectedColorValues)) {  // check if filters contains any selectedColorValues

                          // --------------- size filters
                          if (filters.includes(selectedSizeValues)) {  //check if filters contains any selectedSizeValues
                            
                            // --------------- technology filters
                            if (filters.includes(selectedtechnologyValues)) {  //check if filters contains any selectedtechnologyValues
                              
                              // --------------- material filters
                              if (selectedmaterialValues.length > 0 && filters.includes(selectedmaterialValues)) {
                                products[i].style.display = 'block';
                              }
                              else if (selectedmaterialValues.length == 0) {
                                if (selectedtechnologyValues.length > 0 && filters.includes(selectedtechnologyValues)) {  //check if filters contains any selectedtechnologyValues
                                  products[i].style.display = 'block';
                                }
                                else if (selectedtechnologyValues.length == 0) {
                                  products[i].style.display = 'block';
                                }
                              }
                              else {
                                products[i].style.display = 'none';
                              }
                              // --------------- material filters ---------------
                              
                            }
                            else if (selectedtechnologyValues.length == 0) {
                              if (selectedSizeValues.length > 0 && filters.includes(selectedSizeValues)) {  //check if filters contains any selectedSizeValues
                                products[i].style.display = 'block';
                              }
                              else if (selectedSizeValues.length == 0) {
                                products[i].style.display = 'block';
                              }
                            }
                            else {
                              products[i].style.display = 'none';
                            }
                            // --------------- technology filters ---------------
                          }
                          else if (selectedSizeValues.length == 0) {
                            if (selectedColorValues.length > 0 && filters.includes(selectedColorValues)) {  //check if filters contains any selectedColorValues
                              products[i].style.display = 'block';
                            }
                            else if (selectedColorValues.length == 0) {
                              products[i].style.display = 'block';
                            }
                          }
                          else {
                            products[i].style.display = 'none';
                          }
                          // --------------- size filters ---------------
                          
                        } //ending Color filter if check
                        else {                   
                          products[i].style.display = 'none';
                        }
                        // --------------- color filters ---------------
                        
                      }  //price filters check end
                      else {
                        products[i].style.display = 'none';
                      }
                  } //active & discontinue check end
                  else {
                    products[i].style.display = 'none';
                  }
                }
                else if (category == 'core') {
                  
                  if (filters.includes(productCollection) || filters.includes(productCollection)) {
                    
                      if(filters.includes(selectedPriceValues)) { //check if filters contains any selectedPriceValues

                        // --------------- color filters
                        if (filters.includes(selectedColorValues)) {  // check if filters contains any selectedColorValues

                          // --------------- size filters
                          if (filters.includes(selectedSizeValues)) {  //check if filters contains any selectedSizeValues

                            // --------------- technology filters
                            if (filters.includes(selectedtechnologyValues)) {  //check if filters contains any selectedtechnologyValues
                              
                              //console.log('selectedtechnologyValues', selectedtechnologyValues);
                              // --------------- material filters
                              if (selectedmaterialValues.length > 0 && filters.includes(selectedmaterialValues)) {
                                products[i].style.display = 'block';
                              }
                              else if (selectedmaterialValues.length == 0) {
                                if (selectedtechnologyValues.length > 0 && filters.includes(selectedtechnologyValues)) {  //check if filters contains any selectedtechnologyValues
                                  products[i].style.display = 'block';
                                }
                                else if (selectedtechnologyValues.length == 0) {
                                  products[i].style.display = 'block';
                                }
                              }
                              else {
                                products[i].style.display = 'none';
                              }
                              // --------------- material filters ---------------
                              
                            }
                            else if (selectedtechnologyValues.length == 0) {
                              if (selectedSizeValues.length > 0 && filters.includes(selectedSizeValues)) {  //check if filters contains any selectedSizeValues
                                products[i].style.display = 'block';
                              }
                              else if (selectedSizeValues.length == 0) {
                                products[i].style.display = 'block';
                              }
                            }
                            else {
                              products[i].style.display = 'none';
                            }
                            // --------------- technology filters ---------------
                            
                          }
                          else if (selectedSizeValues.length == 0) {
                            if (selectedColorValues.length > 0 && filters.includes(selectedColorValues)) {  //check if filters contains any selectedColorValues
                              products[i].style.display = 'block';
                            }
                            else if (selectedColorValues.length == 0) {
                              products[i].style.display = 'block';
                            }
                          }
                          else {
                            products[i].style.display = 'none';
                          }
                          // --------------- size filters ---------------
                          
                        }//ending color filter if check
                        else {                 
                          products[i].style.display = 'none';
                        }
                        // --------------- color filters ---------------
                        
                      } //price filters check end
                      else {
                        products[i].style.display = 'none';
                      }
                  } //active & discontinue check end
                  else {
                    products[i].style.display = 'none';
                  }
                }
              }
              else {
                // Apply filtering by active/deactivated
                if (category === 'luxe') {
                  if ((activeChecked && filters.includes('|luxe_active|')) || (deactivatedChecked && filters.includes('|luxe_deactivated|'))) {
                    
                    if(filters.includes(selectedPriceValues)) {

                        // --------------- color filters
                        if (filters.includes(selectedColorValues)) {  // check if filters contains any selectedColorValues

                          // --------------- size filters
                          if (filters.includes(selectedSizeValues)) {  //check if filters contains any selectedSizeValues
                            
                            // --------------- technology filters
                            if (filters.includes(selectedtechnologyValues)) {  //check if filters contains any selectedtechnologyValues
                              
                              // --------------- material filters
                              if (selectedmaterialValues.length > 0 && filters.includes(selectedmaterialValues)) {
                                products[i].style.display = 'block';
                              }
                              else if (selectedmaterialValues.length == 0) {
                                if (selectedtechnologyValues.length > 0 && filters.includes(selectedtechnologyValues)) {  //check if filters contains any selectedtechnologyValues
                                  products[i].style.display = 'block';
                                }
                                else if (selectedtechnologyValues.length == 0) {
                                  products[i].style.display = 'block';
                                }
                              }
                              else {
                                products[i].style.display = 'none';
                              }
                              // --------------- material filters ---------------
                              
                            }
                            else if (selectedtechnologyValues.length == 0) {
                              if (selectedSizeValues.length > 0 && filters.includes(selectedSizeValues)) {  //check if filters contains any selectedSizeValues
                                products[i].style.display = 'block';
                              }
                              else if (selectedSizeValues.length == 0) {
                                products[i].style.display = 'block';
                              }
                            }
                            else {
                              products[i].style.display = 'none';
                            }
                            // --------------- technology filters ---------------
                            
                          }
                          else if (selectedSizeValues.length == 0) {
                            if (selectedColorValues.length > 0 && filters.includes(selectedColorValues)) {  //check if filters contains any selectedColorValues
                              products[i].style.display = 'block';
                            }
                            else if (selectedColorValues.length == 0) {
                              products[i].style.display = 'block';
                            }
                          }
                          else {
                            products[i].style.display = 'none';
                          }
                          // --------------- size filters ---------------
                          
                        }
                        else { // no color values found                          
                          products[i].style.display = 'none';
                        }
                        // --------------- color filters ---------------
                      
                      }
                      else {
                        products[i].style.display = 'none';
                      }
                  } 
                  else {
                    products[i].style.display = 'none';
                    }
                  } 
                else if (category === 'core') {
                    if ((activeChecked && filters.includes(productCollection)) || (deactivatedChecked && filters.includes(productCollection))) {
                      
                      if(filters.includes(selectedPriceValues)) {

                        // --------------- color filters
                        if (filters.includes(selectedColorValues)) {  // check if filters contains any selectedColorValues

                          // --------------- size filters
                          if (filters.includes(selectedSizeValues)) {  //check if filters contains any selectedSizeValues
                            
                            // --------------- technology filters
                            if (filters.includes(selectedtechnologyValues)) {  //check if filters contains any selectedtechnologyValues
                              
                              // --------------- material filters
                              if (selectedmaterialValues.length > 0 && filters.includes(selectedmaterialValues)) {
                                products[i].style.display = 'block';
                              }
                              else if (selectedmaterialValues.length == 0) {
                                if (selectedtechnologyValues.length > 0 && filters.includes(selectedtechnologyValues)) {  //check if filters contains any selectedtechnologyValues
                                  products[i].style.display = 'block';
                                }
                                else if (selectedtechnologyValues.length == 0) {
                                  products[i].style.display = 'block';
                                }
                              }
                              else {
                                products[i].style.display = 'none';
                              }
                              // --------------- material filters ---------------
                            }
                            else if (selectedtechnologyValues.length == 0) {
                              if (selectedSizeValues.length > 0 && filters.includes(selectedSizeValues)) {  //check if filters contains any selectedSizeValues
                                products[i].style.display = 'block';
                              }
                              else if (selectedSizeValues.length == 0) {
                                products[i].style.display = 'block';
                              }
                            }
                            else {
                              products[i].style.display = 'none';
                            }
                            // --------------- technology filters ---------------
                            
                          }
                          else if (selectedSizeValues.length == 0) {
                            if (selectedColorValues.length > 0 && filters.includes(selectedColorValues)) {  //check if filters contains any selectedColorValues
                              products[i].style.display = 'block';
                            }
                            else if (selectedColorValues.length == 0) {
                              products[i].style.display = 'block';
                            }
                          }
                          else {
                            products[i].style.display = 'none';
                          }
                          // --------------- size filters ---------------
                          
                        }
                        else { // no color values found                          
                          products[i].style.display = 'none';
                        }
                        // --------------- color filters ---------------
                        
                      }
                      else {
                        products[i].style.display = 'none';
                      }
                    } 
                    else {
                      products[i].style.display = 'none';
                    }
                  }
                else {
                  products[i].style.display = 'none';
                }
              }
            }
            else {
              products[i].style.display = 'none';
            }
          } //loop end
          updatePriceTags(selectedCollections);
          updateColorTags(selectedCollections);
          updateSizeTags(selectedCollections);
          updatetechnologyTags(selectedCollections);
          updatematerialTags(selectedCollections);
          checkProductBlock();
          sortVisibleProductsByMetafield();
          
          updatePriceTagsAccordionn('price-panel', selectedCollections);
          updateColorTagsAccordionn('color-panel', selectedCollections);
          updateSizeTagsAccordionn('size-panel', selectedCollections);
          updateTechnologyTagsAccordionn('technology-panel', selectedCollections);
          updateMaterialTagsAccordionn('material-panel', selectedCollections);
        }
        else {
          // It shows all products from collection
          if (category == 'luxe' && handle == 'all') {
            
            const allluxe_Collections = ["astron-luxe", "king-seiko-luxe", "presage-luxe", "prospex-luxe"];
            for (let i = 0; i < products.length; i++) {
              const filters = products[i].getAttribute('data-filters');
              
              if (!activeChecked && !deactivatedChecked) {
                if (filters.includes('|luxe_active|') || filters.includes('|luxe_deactivated|')) {

                  if(filters.includes(selectedPriceValues)) { //check if filters contains any selectedPriceValues

                        // --------------- color filters
                        if (filters.includes(selectedColorValues)) {  // check if filters contains any selectedColorValues

                          // --------------- size filters
                          if (filters.includes(selectedSizeValues)) {  //check if filters contains any selectedSizeValues

                            // --------------- technology filters
                            if (filters.includes(selectedtechnologyValues)) {  //check if filters contains any selectedtechnologyValues
                              
                              // --------------- material filters
                              if (selectedmaterialValues.length > 0 && filters.includes(selectedmaterialValues)) {
                                products[i].style.display = 'block';
                              }
                              else if (selectedmaterialValues.length == 0) {
                                if (selectedtechnologyValues.length > 0 && filters.includes(selectedtechnologyValues)) {  //check if filters contains any selectedtechnologyValues
                                  products[i].style.display = 'block';
                                }
                                else if (selectedtechnologyValues.length == 0) {
                                  products[i].style.display = 'block';
                                }
                              }
                              else {
                                products[i].style.display = 'none';
                              }
                              // --------------- material filters ---------------
                              
                            }
                            else if (selectedtechnologyValues.length == 0) {
                              if (selectedSizeValues.length > 0 && filters.includes(selectedSizeValues)) {  //check if filters contains any selectedSizeValues
                                products[i].style.display = 'block';
                              }
                              else if (selectedSizeValues.length == 0) {
                                products[i].style.display = 'block';
                              }
                            }
                            else {
                              products[i].style.display = 'none';
                            }
                            // --------------- technology filters ---------------
                            
                          }
                          else if (selectedSizeValues.length == 0) {
                            if (selectedColorValues.length > 0 && filters.includes(selectedColorValues)) {  //check if filters contains any selectedColorValues
                              products[i].style.display = 'block';
                            }
                            else if (selectedColorValues.length == 0) {
                              products[i].style.display = 'block';
                            }
                          }
                          else {
                            products[i].style.display = 'none';
                          }
                          // --------------- size filters ---------------
                          
                        }//ending color filter if check
                        else {                 
                          products[i].style.display = 'none';
                        }
                        // --------------- color filters ---------------
                        
                      } //price filters check end
                  else {
                    products[i].style.display = 'none';
                  }
                }
              }
              else if ((activeChecked && filters.includes('|luxe_active|')) || (deactivatedChecked && filters.includes('|luxe_deactivated|'))) {
                if(filters.includes(selectedPriceValues)) { //check if filters contains any selectedPriceValues

                        // --------------- color filters
                        if (filters.includes(selectedColorValues)) {  // check if filters contains any selectedColorValues

                          // --------------- size filters
                          if (filters.includes(selectedSizeValues)) {  //check if filters contains any selectedSizeValues

                            // --------------- technology filters
                            if (filters.includes(selectedtechnologyValues)) {  //check if filters contains any selectedtechnologyValues
                              
                              // --------------- material filters
                              if (selectedmaterialValues.length > 0 && filters.includes(selectedmaterialValues)) {
                                products[i].style.display = 'block';
                              }
                              else if (selectedmaterialValues.length == 0) {
                                if (selectedtechnologyValues.length > 0 && filters.includes(selectedtechnologyValues)) {  //check if filters contains any selectedtechnologyValues
                                  products[i].style.display = 'block';
                                }
                                else if (selectedtechnologyValues.length == 0) {
                                  products[i].style.display = 'block';
                                }
                              }
                              else {
                                products[i].style.display = 'none';
                              }
                              // --------------- material filters ---------------
                              
                            }
                            else if (selectedtechnologyValues.length == 0) {
                              if (selectedSizeValues.length > 0 && filters.includes(selectedSizeValues)) {  //check if filters contains any selectedSizeValues
                                products[i].style.display = 'block';
                              }
                              else if (selectedSizeValues.length == 0) {
                                products[i].style.display = 'block';
                              }
                            }
                            else {
                              products[i].style.display = 'none';
                            }
                            // --------------- technology filters ---------------
                            
                          }
                          else if (selectedSizeValues.length == 0) {
                            if (selectedColorValues.length > 0 && filters.includes(selectedColorValues)) {  //check if filters contains any selectedColorValues
                              products[i].style.display = 'block';
                            }
                            else if (selectedColorValues.length == 0) {
                              products[i].style.display = 'block';
                            }
                          }
                          else {
                            products[i].style.display = 'none';
                          }
                          // --------------- size filters ---------------
                          
                        }//ending color filter if check
                        else {                 
                          products[i].style.display = 'none';
                        }
                        // --------------- color filters ---------------
                        
                      } //price filters check end
                  else {
                    products[i].style.display = 'none';
                  }
              }
              else {
                products[i].style.display = 'none';
              }
            }
            //console.log('luxe all');
            updatePriceTags(allluxe_Collections);
            updateColorTags(allluxe_Collections);
            updateSizeTags(allluxe_Collections);
            updatetechnologyTags(allluxe_Collections);
            updatematerialTags(allluxe_Collections);

            checkProductBlock();
            sortAllVisibleProductsByMetafield();
          }
          else if (category == 'core' && handle == 'all') {
            const allcore_Collections = [];
            //const allcore_Collections = ["accessories", "coutura", "diamonds", "essentials", "presage", "prospex", "recraft", "seiko-5-sports"];

            for (let i = 0; i < products.length; i++) {
              const filtersLower = products[i].getAttribute('data-filters');
              const productCollectionLower = products[i].getAttribute('data-collection');
              const productCollection = productCollectionLower.toLowerCase().trim();

              const filters = filtersLower.toLowerCase();              
              // console.log('filters_forloop', filters);

              if (allcore_Collections.indexOf(productCollection) === -1) {
                allcore_Collections.push(productCollection);
              }
                            
              if (!activeChecked && !deactivatedChecked) {
                if (filters.includes('|core_active|') || filters.includes('|core_deactivated|')) {
                  
                  if(filters.includes(selectedPriceValues)) { //check if filters contains any selectedPriceValues

                        // --------------- color filters
                        if (filters.includes(selectedColorValues)) {  // check if filters contains any selectedColorValues

                          // --------------- size filters
                          if (filters.includes(selectedSizeValues)) {  //check if filters contains any selectedSizeValues

                            // --------------- technology filters
                            if (filters.includes(selectedtechnologyValues)) {  //check if filters contains any selectedtechnologyValues
                              
                              // --------------- material filters
                              if (selectedmaterialValues.length > 0 && filters.includes(selectedmaterialValues)) {
                                products[i].style.display = 'block';
                              }
                              else if (selectedmaterialValues.length == 0) {
                                if (selectedtechnologyValues.length > 0 && filters.includes(selectedtechnologyValues)) {  //check if filters contains any selectedtechnologyValues
                                  products[i].style.display = 'block';
                                }
                                else if (selectedtechnologyValues.length == 0) {
                                  products[i].style.display = 'block';
                                }
                              }
                              else {
                                products[i].style.display = 'none';
                              }
                              // --------------- material filters ---------------
                              
                            }
                            else if (selectedtechnologyValues.length == 0) {
                              if (selectedSizeValues.length > 0 && filters.includes(selectedSizeValues)) {  //check if filters contains any selectedSizeValues
                                products[i].style.display = 'block';
                              }
                              else if (selectedSizeValues.length == 0) {
                                products[i].style.display = 'block';
                              }
                            }
                            else {
                              products[i].style.display = 'none';
                            }
                            // --------------- technology filters ---------------
                            
                          }
                          else if (selectedSizeValues.length == 0) {
                            if (selectedColorValues.length > 0 && filters.includes(selectedColorValues)) {  //check if filters contains any selectedColorValues
                              products[i].style.display = 'block';
                            }
                            else if (selectedColorValues.length == 0) {
                              products[i].style.display = 'block';
                            }
                          }
                          else {
                            products[i].style.display = 'none';
                          }
                          // --------------- size filters ---------------
                          
                        }//ending color filter if check
                        else {                 
                          products[i].style.display = 'none';
                        }
                        // --------------- color filters ---------------
                        
                      } //price filters check end
                  else {
                    products[i].style.display = 'none';
                  }
                }
              }
                
              else if ((activeChecked) || (deactivatedChecked)) {
                if(filters.includes(selectedPriceValues)) { //check if filters contains any selectedPriceValues

                        // --------------- color filters
                        if (filters.includes(selectedColorValues)) {  // check if filters contains any selectedColorValues

                          // --------------- size filters
                          if (filters.includes(selectedSizeValues)) {  //check if filters contains any selectedSizeValues

                            // --------------- technology filters
                            if (filters.includes(selectedtechnologyValues)) {  //check if filters contains any selectedtechnologyValues
                              
                              // --------------- material filters
                              if (selectedmaterialValues.length > 0 && filters.includes(selectedmaterialValues)) {
                                products[i].style.display = 'block';
                              }
                              else if (selectedmaterialValues.length == 0) {
                                if (selectedtechnologyValues.length > 0 && filters.includes(selectedtechnologyValues)) {  //check if filters contains any selectedtechnologyValues
                                  products[i].style.display = 'block';
                                }
                                else if (selectedtechnologyValues.length == 0) {
                                  products[i].style.display = 'block';
                                }
                              }
                              else {
                                products[i].style.display = 'none';
                              }
                              // --------------- material filters ---------------
                              
                            }
                            else if (selectedtechnologyValues.length == 0) {
                              if (selectedSizeValues.length > 0 && filters.includes(selectedSizeValues)) {  //check if filters contains any selectedSizeValues
                                products[i].style.display = 'block';
                              }
                              else if (selectedSizeValues.length == 0) {
                                products[i].style.display = 'block';
                              }
                            }
                            else {
                              products[i].style.display = 'none';
                            }
                            // --------------- technology filters ---------------
                            
                          }
                          else if (selectedSizeValues.length == 0) {
                            if (selectedColorValues.length > 0 && filters.includes(selectedColorValues)) {  //check if filters contains any selectedColorValues
                              products[i].style.display = 'block';
                            }
                            else if (selectedColorValues.length == 0) {
                              products[i].style.display = 'block';
                            }
                          }
                          else {
                            products[i].style.display = 'none';
                          }
                          // --------------- size filters ---------------
                          
                        }//ending color filter if check
                        else {                 
                          products[i].style.display = 'none';
                        }
                        // --------------- color filters ---------------
                        
                      } //price filters check end
                      else {
                        products[i].style.display = 'none';
                      }
              }
              else {
                products[i].style.display = 'none';
              }
            }
            //console.log('core all');
            updatePriceTags(allcore_Collections);
            updateColorTags(allcore_Collections);
            updateSizeTags(allcore_Collections);
            updatetechnologyTags(allcore_Collections);
            updatematerialTags(allcore_Collections);
            checkProductBlock();
            sortAllVisibleProductsByMetafield();
            
            updatePriceTagsAccordionn('price-panel', allcore_Collections);
            updateColorTagsAccordionn('color-panel', allcore_Collections);
            updateSizeTagsAccordionn('size-panel', allcore_Collections);
            updateTechnologyTagsAccordionn('technology-panel', allcore_Collections);
            updateMaterialTagsAccordionn('material-panel', allcore_Collections);
          }
        }  
     }

    function sortVisibleProductsByMetafield() {
      // console.log(products);
      const visibleProducts = Array.from(products).filter(product => product.style.display === 'block');
      // console.log('visibleProducts1', visibleProducts);
      
      visibleProducts.sort((a, b) => {
          //Retrieves and converts the data-metafields attribute of product a into an integer
          const metafieldA = parseInt(a.getAttribute('data-metafields'), 10); //The 10 specifies the base (decimal).
          const metafieldB = parseInt(b.getAttribute('data-metafields'), 10);
  
          //both metafield values are not numbers
          if (isNaN(metafieldA) && isNaN(metafieldB)) return 0;

          //If metafieldA is invalid but metafieldB is valid, move product a with invalid metafield to the end.
          if (isNaN(metafieldA)) return 1;
        
          //If metafieldB is invalid but metafieldA is valid, move product b with invalid metafield to the end.
          if (isNaN(metafieldB)) return -1;

          //Both metafields are valid numbers, sort them in ascending order.
          return metafieldA - metafieldB; // Ascending order
      });
      
      const productsContainer = document.querySelector('.product_block_margin'); // Adjust selector to match your container
      visibleProducts.forEach(product => {
          productsContainer.appendChild(product); // Re-append each product in the new order
      });
    }

    function sortAllVisibleProductsByMetafield() {
      // Get all visible products
      const visibleProducts = Array.from(products).filter(product => product.style.display === 'block');
      // console.log('visibleProducts2', visibleProducts);
  
      // Clear the products container before appending sorted products
      const productsContainer = document.querySelector('.product_block_margin'); // Adjust selector to match your container
      productsContainer.innerHTML = ''; // Clear existing products
  
      // Create a Set to track unique products
      const seenProducts = new Set();
      
      // Sort products based on metafields
      visibleProducts.sort((a, b) => {
          const metafieldA = parseInt(a.getAttribute('data-metafields'), 10);
          const metafieldB = parseInt(b.getAttribute('data-metafields'), 10);
  
          if (isNaN(metafieldA) && isNaN(metafieldB)) return 0;
          if (isNaN(metafieldA)) return 1;
          if (isNaN(metafieldB)) return -1;
  
          return metafieldA - metafieldB;
      });
  
      // Append sorted products to the container, ensuring no duplicates
      visibleProducts.forEach(product => {
          const filters = product.getAttribute('data-filters');
          const metafields = product.getAttribute('data-metafields');
  
          // Create a unique key for each product based on its attributes
          const uniqueKey = `${filters}-${metafields}`;
  
          if (!seenProducts.has(uniqueKey)) {
              seenProducts.add(uniqueKey); // Mark this product as seen
              productsContainer.appendChild(product); // Add the product to the container
          } else {
              // console.warn('Skipping duplicate product due to matching attributes:', product);
          }
      });
    }

    function checkProductBlock() {
      let productBlock = $('.product_block');
      let hasVisibleProducts = false;
    
      productBlock.children().each(function() {
        if ($(this).is(':visible')) {
          hasVisibleProducts = true;
          return false; // Break out of the loop
        }
      });
    
      if (hasVisibleProducts) {
        $('#message_div').hide();
        // console.log('product_block contains visible products - hide message_div');
      } else {
        $('#message_div').show();
        // console.log('product_block contains no visible products - show message_div');
      }
    }

    $(document).ready(function() {
    
        if ($('.product_block').length >= 0) {
          $('#loader').hide();
          $('#loader2').hide();

          var div = document.getElementById("blurr-id");
          div.classList.remove("blurry-div");

          setTimeout(function() {

            setTimeout(function() {
              checkProductBlock();
            }, 100);
          }, 1500);
          
          $('.wrapper').show();
        }
    });

    $(document).ready(function() {
      setTimeout(checkProductBlock, 1100); // Delay of 1 seconds
    });

    resetButtonMain.addEventListener('click', function() {
      reset_filters();
    });

    resetButton.addEventListener('click', function() {
      reset_filters();
    });

    function reset_filters() {
      selectedPriceValues = [];
      selectedColorValues = [];
      selectedSizeValues = [];
      selectedtechnologyValues = [];
      selectedmaterialValues = [];
    
      // Log the reset action (optional)
      //console.log('Filters have been reset.');
    
      // Update the UI to reflect the reset state
      updatePriceTags([]); // Reset price tags
      updateColorTags([]);
      updateSizeTags([]);
      updatetechnologyTags([]);
      updatematerialTags([]);
      
      // Optionally, call the function to re-filter the products
      filterProducts();
    }

    var count = 0;
    function count_visibleChild_products() {
      if ($('.product_block').length > 0) {
        var visibleChildrenCount = $('.product_block').children(':visible').length;
        count++;
        console.log('count', count);
        console.log('visibleChildrenCount', visibleChildrenCount);
      }
    }
 });